import * as types from '../mutation-types';
import api from '../../helpers/api';


export default {
  state: {
    all: [],
  },
  getters: {
    getSliders: (state) => state.all,
  },
  actions: {
    async getAllSliders({ commit }) {
      const sliders = await api.get('sliders');
      commit(types.RECEIVED_SLIDERS, { sliders });
    },
  },
  mutations: {
    [types.RECEIVED_SLIDERS](state, { sliders }) {
      state.all = sliders;
    },
  },
};
